export const pending = 'Pending'
export const approved = 'Approved'
export const declined = 'Declined' // deprecated, kept due to old data and code
export const rejected = 'Rejected'

export const status = {
  pending,
  approved,
  declined,
  rejected,
}

// Map status to the corresponding mui color
export const STATUS_COLOR_MAP = {
  [pending]: 'primary',
  [approved]: 'success',
  [declined]: 'error',
  [rejected]: 'error',
}
